import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserMissingIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM10 14c.552 0 1.01-.452.9-.994a5.002 5.002 0 0 0-9.802 0c-.109.542.35.994.902.994h8Z",
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M11 3.5v0A1.5 1.5 0 0 1 12.5 2h.197C13.417 2 14 2.583 14 3.303v0c0 .435-.218.842-.58 1.084l-.32.213c-.375.25-.6.67-.6 1.121V6" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: .25,
			cy: .25,
			r: .25,
			transform: "matrix(-1 0 0 1 12.75 8)"
		})
	]
});
export default SvgUserMissingIcon;
